import React from "react";

import { formatting } from "@north-beam/nb-common";

interface Props {
  settings: Record<string, { name: string; ignoreTextFormat: boolean }[]>;
}

export const TagettingSettings = ({ settings }: Props) => (
  <div className="mt-8">
    <h3 className="text-lg font-bold">Targeting</h3>
    {Object.entries(settings).map(([key, values]) => (
      <div key={key} className="mb-3">
        <div className="mb-0.5">
          {formatting.formatStringToReadableText(key)}
        </div>
        <div className="text-xs text-gray+1">
          {values
            .map((e, i) =>
              e.ignoreTextFormat
                ? e.name
                : formatting.formatStringToReadableText(e.name),
            )
            .join(", ")}
        </div>
      </div>
    ))}
  </div>
);
